import { get, patch, post, remove } from 'vio-libs';
export function getEdgeConnections(organization, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`edge-connections?organization=${organization}`);
    }
    return get(`v1/${organization}/kex/connections?expand=offering`, undefined, true);
}
export function getEdgeOfferingConnections(organization, edgeOfferingId, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`edge-connections?organization=${organization}&edge_offering=${edgeOfferingId}`);
    }
    return get(`v1/${organization}/kex/connections?offering=${edgeOfferingId}`, undefined, true);
}
export function postNewEdgeConnections(organization, edgeOfferingId, edgeConnection, consumerAPI = false) {
    if (!consumerAPI) {
        return post(`edge-connections?organization=${organization}`, {
            data: Object.assign({ edge_offering_id: edgeOfferingId }, edgeConnection)
        });
    }
    return post(`v1/${organization}/kex/connections?expand=offering`, {
        data: Object.assign({ edge_offering_id: edgeOfferingId }, edgeConnection)
    }, true);
}
export function patchExistingEdgeConnection(organization, edgeConnectionId, update, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`edge-connections?organization=${organization}`, {
            data: Object.assign({ edge_connection_id: edgeConnectionId }, update)
        });
    }
    return patch(`v1/${organization}/kex/connections/${edgeConnectionId}?expand=offering`, {
        data: Object.assign({}, update)
    }, true);
}
export function removeEdgeConnection(organization, edgeConnectionId, consumerAPI = false) {
    if (!consumerAPI) {
        return remove(`edge-connections?organization=${organization}`, {
            data: {
                edge_connection_id: edgeConnectionId
            }
        });
    }
    return remove(`v1/${organization}/kex/connections/${edgeConnectionId}`, undefined, true);
}
